import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    snackbar: {
      text: '',
      show: false,
    },
    user: {
      id: '',
      surname: '',
      name: '',
      patronymic: '',
      phone: '',
      role: 0,
    },
    dict: {
      role: {},
    },
    lock: [],
    settings: [],
    barColor: 'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
    drawer: null,
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
    SET_LOCK_ON (state, id) {
      state.lock.push(id)
    },
    SET_LOCK_OFF (state, id) {
      state.lock = state.lock.filter(a=>a!=id)
    },
    snackbar (state, data) {
      state.snackbar.text = data
      state.snackbar.show = true
    },
    user (state, user) {
      state.user = user
    },
    client (state, client) {
      state.client = client
    },
    dictionary (state, dict) {
      state.dict = dict
    },
    settings (state, settings) {
      state.settings = settings
    },
  },
  actions: {

  },
})
